/* tslint:disable */
/* eslint-disable */
/**
 * Careplatform User API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: jonas.malik@magello.se
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    UserAuthorityType,
    UserAuthorityTypeFromJSON,
    UserAuthorityTypeFromJSONTyped,
    UserAuthorityTypeToJSON,
} from './';

/**
 * 
 * @export
 * @interface UpdateUserAuthoritiesRequest
 */
export interface UpdateUserAuthoritiesRequest {
    /**
     * 
     * @type {Array<UserAuthorityType>}
     * @memberof UpdateUserAuthoritiesRequest
     */
    userAuthorities: Array<UserAuthorityType>;
}

export function UpdateUserAuthoritiesRequestFromJSON(json: any): UpdateUserAuthoritiesRequest {
    return UpdateUserAuthoritiesRequestFromJSONTyped(json, false);
}

export function UpdateUserAuthoritiesRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateUserAuthoritiesRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'userAuthorities': ((json['userAuthorities'] as Array<any>).map(UserAuthorityTypeFromJSON)),
    };
}

export function UpdateUserAuthoritiesRequestToJSON(value?: UpdateUserAuthoritiesRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'userAuthorities': ((value.userAuthorities as Array<any>).map(UserAuthorityTypeToJSON)),
    };
}


